import { Component, OnInit, EventEmitter, Output, Input, Optional } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';

import { Utils } from '../../services/utils.service';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig]
})
export class FormComponent implements OnInit {
  constructor(private utils: Utils,
    private dialogService: DialogService) { }
  @Input() templateSource: any[];
  @Input() configs: any;
  @Input() callbacks: object;
  @Output() submit?: any = new EventEmitter();
  @Output() onChangeACSelection?: any = new EventEmitter();
  @Output() onChangeTextField?: any = new EventEmitter();
  form: FormGroup;
  isdecimal: string;

  updateForm(formValues, scope) {
    for (let control in scope.form.controls) {
      const isPicker = scope.templateSource.find((elem) => elem.id === control && elem.type === 'picker');
      if (isPicker) {
        scope.form.controls[control].patchValue(moment(formValues[control], "DD/MM/YYYY")['_d']);
        return;
      }
      scope.form.controls[control].patchValue(formValues[control]);
    }
  }

  onSubmitFilterCriteria(formData: any, templateSource?: any) {
    const formDataValues = { ...formData };
    for (const control in formDataValues) {
      const template = templateSource.find(x => x.id === control);
      if (template.type !== 'multiselect') {
        if (formDataValues[control]) {
          if (template && formDataValues[control] instanceof Date && template.type === 'picker') {
            if (moment(formDataValues[control]).isValid()) {
              formDataValues[control] = moment(formDataValues[control]).format(template.dateFormat ? template.dateFormat : 'DD/MM/YYYY');
            }
          } else if (typeof formDataValues[control] === 'object') {
            formDataValues[control] = formDataValues[control].id;
          }
        }
      } else {
        if (formDataValues[control] && (formDataValues[control].length && formDataValues[control] !== 'ALL')) {
          let multiSelectArr = '';
          if (template.seperator) {
            formDataValues[control].forEach(element => {
              multiSelectArr += multiSelectArr ? (template.seperator + element.id) : (element.id);
            });
            formDataValues[control] = multiSelectArr;
          }
        } else {
          formDataValues[control] = 'ALL'
        }
      }
    }
    this.submit.emit(formDataValues);
  }

  resetForm(formData, scope, templateSource) {
    const formDataValues = { ...formData };
    for (const control in formDataValues) {
      const template = templateSource.find(x => x.id === control);
      if (template.type === 'multiselect') {
        scope.form.controls[control].patchValue(null);
        formDataValues[control] = 'ALL';
      } else {
        if (formDataValues[control] instanceof Date) {
          scope.form.controls[control].patchValue('');
          formDataValues[control] = '';
        } else if (typeof formDataValues[control] === 'object' && template.type !== 'picker') {
          const value = template.defaultValue ? template.defaultValue : ({ id: 'ALL', value: 'ALL' });
          scope.form.controls[control].patchValue(value);
          formDataValues[control] = value.id;
        } else {
          scope.form.controls[control].patchValue('');
          formDataValues[control] = '';
        }
      }
    }
    if (scope.configs.isReset) {
      formDataValues['isReset'] = true;
    }
    scope.submit.emit(formDataValues);
  }

  onReset(formData: any, template) {
    this.resetForm(formData, this, template);
  }

  onSelect($event, template) {
    if (template['toDateId']) {
      const toDateIndex = this.templateSource.findIndex((elem) => elem.id === template['toDateId']);
      this.templateSource[toDateIndex].minDate = this.form.value[template.id];
    }
  }

  onBlurInputText(template) {
    if (!template['isdecimal']) {
      return;
    }
    const values = this.form.value[template.id];
    if (!isNaN(values)) {
      this.form.controls[template.id].patchValue(parseFloat(values).toFixed(template['isdecimal']));
    }
  }

  showAsterisk(control) {
    const field = this.form.controls[control];
    const template = this.templateSource.find((elem) => elem.id === control);
    if (!field.validator || !field.validator(control)) {
      template.showAsterisk = false;
      return;
    }
    const isFieldRequired = field.validator(control).required;
    template.showAsterisk = isFieldRequired;
  }

  onClickHelper(controlConfig) {
    const config = controlConfig;
    const ref = this.dialogService.open(config.helperConfig.modalComponent(config.scope, config.id), {
      data: { enableMultiSelect: config.helperConfig.selection },
      header: config.helperConfig.title,
      width: config.helperConfig.width ? config.helperConfig.width : '70%',
      contentStyle: { "max-height": "350px", "overflow": "auto" }
    });

    ref.onClose.subscribe((response) => {
      config.helperConfig.helperCallback(response, config.scope, config.id);
    });
  }

  onEnterKeyUp(template, scope) {
    if (!template.isHelper && !template.allowOnlyEnter) {

      return;
    }
    template.onEnter(this.form.controls[template.id].value, template.scope, template.id);
  }

  onSelectCheckbox(template) {
    if (template.onSelect) {
      template.onSelect(this.form.value[template.id], template.id, template.scope);
    }
  }

  onLoadGrid(template) {
    if (template.isDisabled) {

    }
  }

  onChangeMultiSelect(event, template, isSelectedAll?) {
    if (template.onSelectedItems) {
      template.onSelectedItems(event, template.scope, template.id, event.isSelectedAll);
    }
  }

  onClick(template) {
    template.onClick(template.scope, this, template);
  }

  onClickUpload(event, template) {
    template.onClickFileUpload(event, template.scope);
  }

  onChangeInputText(event) {
    this.onChangeTextField.emit(event);
  }

  onAfterPickerOpened(template) {
    if (template.afterPickerOpened) {
      template.afterPickerOpened();
    }
  }

  ngOnInit() {
    this.form = this.configs.formGroup ? this.configs.formGroup : this.utils.constructFormControlGroup(this.templateSource);
    if (this.callbacks) {
      this.callbacks['updateForm'] = this.updateForm;
      this.callbacks['reset'] = this.resetForm;
      this.callbacks['scope'] = this;
    }

    for (const field in this.form.controls) {
      this.showAsterisk(field);
    }
  }
}




